export const missionsMixin = {
  data() {
    return {
      parentIdNext: '0',
      templateUpIn: null,
      templatesUp: [],
      matchUp: false,
      activeM: [],
      templatesIds: [],
      match: false,
      templateSelectedIn: null
    }
  },
  methods: {
    recursiveSearchUp(obj, id) {
      for (const children in obj) {
        if (this.matchUp) break

        if (children === 'where') {
          continue
        }

        if (typeof obj[children] === 'object' && obj[children] !== null) {
          if (obj[children].id === id) {
            this.templateUpIn = obj[children]
            this.templatesUp.push(this.templateUpIn)
            this.matchUp = true
            this.parentIdNext = this.templateUpIn.parentId
            break
          } else {
            this.recursiveSearchUp(obj[children], id)
          }
        }
      }

      return true
    },
    recursiveSearchM(obj) {
      for (const children in obj) {
        if (this.match) break

        if (typeof obj[children] === 'object' && obj[children] !== null) {
          if (obj[children].id === this.activeM[0]) {
            this.templateSelectedIn = obj[children]
            this.match = true
            break
          } else this.recursiveSearchM(obj[children])
        }
      }
      return this.templateSelectedIn
    },
    recursiveSearchInM(obj) {
      for (const children in obj) {
        if (typeof obj[children] === 'object' && obj[children] !== null) {
          if (obj[children].id !== undefined) this.templatesIds.push(obj[children].id)
          this.recursiveSearchInM(obj[children])
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/missionsMixin.js